import loader from '../loader';
import { ProviderCallback, ProviderPermissions, ProviderRedirectResponse } from '.';

const GOOGLE_CLIENT_ID = '248891864768-88msobpmnk91n8lb0j0mpcsmi9hmh9lq';

export default class GoogleOAuth {

    static readonly BASIC_SCOPES: string[] = ['https://www.googleapis.com/auth/userinfo.email', 'https://www.googleapis.com/auth/userinfo.profile'];

    readonly permissions: string[];

    private permissionsStringified: string;

    constructor(
        private scopes: ProviderPermissions,
        private redirectURI: string,
        private callback: ProviderCallback
    ) {
        this.permissions = [...GoogleOAuth.BASIC_SCOPES, ...scopes];

        this.permissionsStringified = this.permissions.join(' ');

        loader.loadJS('https://accounts.google.com/gsi/client').catch(callback);
    }

    static hasPermissions(search: string[], target: string[]) {
        for (const permission of search)
            if (!target.includes(permission))
                return false;

        return true;
    }

    static handleRedirect(): ProviderRedirectResponse {
        const response: Partial<{ code: string, state: string, scope: string }> = Array.from(new URLSearchParams(window.location.search))
            .reduce<{ [key: string]: string }>((params, [key, value]) => ({ ...params, [key]: value }), {});

        if (!response.code || !response.state || !response.scope)
            return { error: 'invalid-response' };

        try {
            var state: { path: string, permissions: string[] } = JSON.parse(atob(response.state));

            if (!state.path || !state.permissions)
                return { error: 'invalid-response' };

            var permissions = response.scope.split(' ');

            if (!GoogleOAuth.hasPermissions([...GoogleOAuth.BASIC_SCOPES, ...state.permissions], permissions))
                return { token: response.code, permissions, redirect: state.path, error: 'permissions-denied' };
        } catch (error) {
            return { error: 'invalid-response' };
        }

        return { token: response.code, permissions, redirect: state.path };
    }

    connect(target?: string) {
        window.google?.accounts.oauth2.initCodeClient({
            client_id: GOOGLE_CLIENT_ID,
            scope: this.permissionsStringified,
            hint: target,
            ux_mode: 'redirect',
            redirect_uri: this.redirectURI,
            state: btoa(JSON.stringify({ path: window.location.pathname, permissions: this.scopes })),
            // @ts-ignore
            error_callback: () => this.callback({ error: 'unknown' })
        })
        .requestCode();
    }

}
